import Api from './api';

/**
 * Spam-domain blocklist admin API.
 *
 * Thin wrappers over the shared `Api` client for the admin domain-management
 * endpoints. All are admin-only; `{ silent: true }` so callers handle errors
 * inline (403 -> access-denied state) instead of the global error toast.
 */

const buildQuery = (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && value !== 'all') {
      params.append(key, String(value));
    }
  });
  const qs = params.toString();
  return qs ? `?${qs}` : '';
};

/** GET /api/admin/moderation/domains/list -> { data: { items }, pagination } */
export const getSpamDomains = (filters = {}) =>
  Api.get(`/admin/moderation/domains/list${buildQuery(filters)}`, null, { silent: true });

/** POST /api/admin/moderation/domains/create -> { data: SpamDomain, msg } */
export const createSpamDomain = (domain) =>
  Api.post('/admin/moderation/domains/create', { domain }, null, { silent: true });

/** POST /api/admin/moderation/domains/update/:domainId -> { data: SpamDomain, msg } */
export const updateSpamDomain = (domainId, active) =>
  Api.post(`/admin/moderation/domains/update/${domainId}`, { active }, null, { silent: true });

/** DELETE /api/admin/moderation/domains/remove/:domainId -> { data: { deleted }, msg } */
export const removeSpamDomain = (domainId) =>
  Api.delete(`/admin/moderation/domains/remove/${domainId}`, null, null, { silent: true });
